module.exports = __webpack_public_path__ + "img/en.a57bacfb.png";